import fetcher from "../../../lib/fetcher";
import useSWRMutation from "swr/mutation";
import { FacilityTypeSchema, FacilityTypeSchemaResponseWrapper } from "./types";

const ERROR_MESSAGE = "Не удалось получить типы квартир";

const useReitTypeList = () => {
  async function fetchTypeList(url: string) {
    try {
      const data = await fetcher.swr<FacilityTypeSchemaResponseWrapper>(url);
      return data.data as FacilityTypeSchema[];
    } catch (error) {
      console.log(error, ERROR_MESSAGE);
      throw ERROR_MESSAGE;
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    `facility/reit-list/type`,
    fetchTypeList
  );

  return {
    reitListType: data,
    error,
    isMutating,
    trigger,
  };
};

export default useReitTypeList;
